import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { stageCompleteStatusByApprover } from '../../../actions/projectTimelineActions'
import DisapproveModal from '../Components/ReusableComponent/DisapproveModal'
import logo from '../../../assets/icons/MetaBrief_horizontal_RBG.jpg'

const CompleteStage = (props) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [projectID, setProjectID] = useState()
    // const [code, setCode] = useState()
    const [inputID, setInputID] = useState()
    const [showRejectModal, setAddRejectModal] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(false);

    const { user, loading } = useSelector(state => state.auth)

    useEffect(() => {
        const queryParams = new URLSearchParams(props.location.search)
        // const projectId = queryParams.get("project_id")
        const url = `${props.location.pathname}${props.location.search}`;

        localStorage.setItem('redirectUrl', url);
        console.log(url)
        if (!user) history.push('/login')
        if (props.match.params.id) {
            setInputID(props.match.params.id)
            const projectId = queryParams.get("project_id")
            setProjectID(projectId);
        }
    }, [props, history, user])


    const handleClickAcceptInvitation = (acceptStatus) => {
        const formData = {
            is_approved: acceptStatus,
            project_id: projectID,
            timeline_stage_id: inputID,
        }
        dispatch(stageCompleteStatusByApprover(formData, history));
    }
    const handleAddReasonClose = () => {
        setAddRejectModal(false);
        setSelectedRowData(false);
    };
    const handleReasonShow = () => {
        const data = {
            project_id: projectID,
            stage_id: inputID
        }
        setSelectedRowData(data);
        setAddRejectModal(true);
    };
    return (
        <>
            <div id="wrapper" className="a uth-main">
                <div className="container">
                    <div className="row clearfix">
                        <div className='col-md-4 mx-auto'>
                            <div className="card custom_card border-radius-10">
                                <div className="header text-center pb-0">
                                    <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>
                                    <h4 className="lead"><strong>Accept stage complete</strong></h4>
                                </div>
                                <div className="body">
                                    <div className="body modal-body">
                                        <div className="form-auth-small">
                                            <div className="form-group">
                                                <label>Accept invitation stage complete for owners</label>
                                            </div>
                                            <div className='row'>
                                                <div className='col-sm-12 col-md-6 col-lg-6'>
                                                    <button className="btn custom-btn-outline-info btn-sm btn-block" onClick={() => handleClickAcceptInvitation(true)} disabled={loading ? true : false}>Accept</button>
                                                </div>
                                                <div className='col-sm-12 col-md-6 col-lg-6'>
                                                    <button className="btn btn-outline-danger btn-sm btn-block"  onClick={() => handleReasonShow()}>Decline</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DisapproveModal
                open={showRejectModal}
                close={handleAddReasonClose}
                data={selectedRowData}
                component={'TimelineStageStatus'}
            />
        </>
    );
};

export default CompleteStage;
